if (!customElements.get('newsletter-modal')) {

  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalDialog {
      constructor() {
        super();
        this.fields = [
          {
            key: "first_name",
            selector: "input[name='newsletter[Name]']"
          },
          {
            key: "state",
            selector: "select[name='newsletter[State]']"
          },
          {
            key: "customer_type",
            selector: "input[name='newsletter[Customer_Type]']:checked"
          }
        ];

        this.selectors = {
          newsletterForm: ".newsletter-modal__form",
          newsletterSignUpSuccessContainer: ".newsletter-modal__success-container"
        };
      }

      hide() {
        super.hide();
        this.handleFormDisplay(true);
        this.resetFields();
      }

      show(opener) {
        super.show(opener);
      }

      resetFields() {
        this.fields.forEach((field) => {
          const fieldElement = this.querySelector(field.selector);
          if (fieldElement) {
            if (fieldElement.type === "radio") {
              fieldElement.checked = false;
            } else {
              fieldElement.value = "";
            }
          }
        })
      }

      handleFormDisplay(show) {
        const formElement = this.querySelector(this.selectors.newsletterForm);
        const successElement = this.querySelector(this.selectors.newsletterSignUpSuccessContainer);
        if (show) {
          formElement.classList.remove("hidden");
          successElement.classList.add("hidden");
        } else {
          formElement.classList.add("hidden");
          successElement.classList.remove("hidden");
        }
      }

      async submitForm(event, submitAdditionalDetails) {
        event.preventDefault();
        const email = document.querySelector("form.newsletter-form input[name='contact[email]']")?.value;
        const fields = this.fields.map(({ key, selector }) => {
          const field = this.querySelector(selector)
          const value = field?.value || "";
          return {
            key,
            value
          }
        });
        const properties = fields.reduce((prev, curr) => {
          return {
            ...prev,
            [curr.key]: curr.value
          }
        }, {})
        const PUBLIC_API_KEY = window.klaviyoSettings.publicApiKey;
        const LIST_ID = window.klaviyoSettings.newsletterSignUpListId;
        const API_REVISION = '2023-10-15';

        // // Your form data here
        const source = 'Footer_Sign_Up_Form';

        // // The API data schema, docs here: https://developers.klaviyo.com/en/reference/create_client_subscription

        let attributes = {
          email
        };

        if (submitAdditionalDetails) {
          attributes = {
            ...attributes,
            first_name: properties.first_name,
            properties: {
              customer_state: properties.state,
              customer_type: properties.customer_type
            }
          };
        }

        const data = {
          data: {
            "type": "subscription",
            "attributes": {
              "custom_source": `${source}`,
              "profile": {
                "data": {
                  "type": "profile",
                  attributes
                }
              }
            },
            "relationships": {
              "list": {
                "data": {
                  "type": "list",
                  "id": `${LIST_ID}`
                }
              }
            }
          }
        };

        try {
          const response = await fetch(
            `https://a.klaviyo.com/client/subscriptions/?company_id=${PUBLIC_API_KEY}`, {
            method: 'POST',
            headers: {
              'content-type': 'application/json',
              revision: API_REVISION,
            },
            body: JSON.stringify(data),
          });

          if (!response.ok) throw Error(`could not submit to klaviyo: ${response.status}`);

          if (submitAdditionalDetails) {
            this.handleFormDisplay(false);
          } else {
            this.hide();
          }

        } catch(e) {
          console.error(e);
        }
      }
    }
  );
}
